export default __webpack_public_path__ + "static/src/companys/ttl/assets/images/logo/logo_light.svg";